module.exports = __webpack_public_path__ + "img/dwd.bad76b21.png";